// extracted by mini-css-extract-plugin
export default {"MainContent":"Home_MainContent__lo1h1","Title":"Home_Title__M3uIk","Separator":"Home_Separator__pTFC6","Introduction":"Home_Introduction__r6s94","MainBlock":"Home_MainBlock__RbxAU"};